<div class="date-of-birth-field" lxDetectOutsideClick (clickOutside)="markTouchedOnOutsideFocus()" (focusin)="onInternalInteraction()">
  <p-inputMask
    class="date-of-birth-field__day"
    placeholder="DD"
    i18n-placeholder
    mask="99"
    [slotChar]="''"
    [autoClear]="false"
    [(ngModel)]="day"
    (ngModelChange)="updateDateOfBirth()"
    (onFocus)="onInternalInteraction()"
    data-qa="dateOfBirthField_day"
  />
  <p-dropdown
    (onChange)="updateMonthOfDateOfBirth()"
    [(ngModel)]="month"
    [options]="months"
    [overlayOptions]="overlayOption"
    [scrollHeight]="monthScrollHeight"
    [style]="{ width: '100%' }"
    class="date-of-birth-field__month"
    data-qa="dateOfBirthField_month"
    i18n-placeholder
    optionLabel="name"
    optionValue="code"
    placeholder="Month"
    (onFocus)="onInternalInteraction()"
  />
  <p-inputNumber
    (onInput)="updateDateOfBirth()"
    [(ngModel)]="year"
    [format]="false"
    [maxlength]="4"
    [minlength]="4"
    class="date-of-birth-field__year"
    data-qa="dateOfBirthField_year"
    i18n-placeholder
    placeholder="YYYY"
    (onFocus)="onInternalInteraction()"
  />
</div>
